/**
 *
 * Created Date: 2019-03-27, 19:59:20 (zhenliang.sun)
 * Last Modified: 2019-08-14, 16:37:42 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import { fabric } from 'fabric';
import UndoManager from '../manager/UndoManager';
import { GraphName, GraphType } from './../constants/Constants';
import CanvasTriangleBase from './CanvasTriangleBase';

/**
 * 直角三角形
 *
 * @export
 * @class CanvasRightTriangle
 * @extends {CanvasTriangleBase}
 * @author zhenliang.sun
 */
export default class CanvasRightTriangle extends CanvasTriangleBase {
  constructor(app) {
    super(app);
  }

  static toAddData(target) {
    let obj = CanvasTriangleBase.toAddData(target);
    obj.gtype = GraphType.RIGHT_TRIANGLE;
    obj.path = target.path;
    return obj;
  }

  _mouseDownHandler(o) {
    super._mouseDownHandler(o);

    let path = 'M 0 0 L 0 3 L 5 3 z';
    this._triangle = new fabric[GraphName.RIGHT_TRIANGLE](path, {
      left: this.ox,
      top: this.oy,
      objectCaching: false,
      stroke: this._option.stroke,
      strokeWidth: this._option.strokeWidth,
      fill: null,
      selectable: false,
      strokeLineCap: 'round',
      strokeLineJoin: 'round',
      strokeMiterLimit: 1
    });

    this.root.add(this._triangle);
  }
  _mouseMoveHandler(o) {
    super._mouseMoveHandler(o);
    if (!this._isMouseDown) {
      return;
    }

    let sp = this.root.getPointer(o.e);
    let p1 = (sp.y - this.oy).toFixed(1);
    let p2 = (sp.x - this.ox).toFixed(1);
    let path = `M 0 0 L 0 ${p1} L ${p2} ${p1} z`;
    let p = new fabric[GraphName.RIGHT_TRIANGLE](path, {
      selectable: false
    });

    this._triangle.set({
      path: p.path,
      width: p.width,
      height: p.height,
      pathOffset: p.pathOffset
    });

    if (p.left < 0) {
      this._triangle.left = this.ox + p.left;
    }

    if (p.top < 0) {
      this._triangle.top = this.oy + p.top;
    }

    this.stage.renderNow();
  }
  _mouseUpHandler(o) {
    super._mouseUpHandler(o);
    this._triangle.setCoords();
    this.stage.renderNow();

    let data = this.factory.createAddData(this._triangle);
    // MsgSender.add(data)
    this.app.sender.add(data);

    let allData = this.root.toDatalessJSON();
    UndoManager.getInstance().save(allData);
  }
}
